"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dynatrace = void 0;
var features_1 = require("../../features");
Object.defineProperty(exports, "Dynatrace", { enumerable: true, get: function () { return features_1.Dynatrace; } });
//# sourceMappingURL=index.js.map